<template>
  <BaseModal
    :fullscreen="true"
    :open.sync="open"
    :hideCloseBtn="false"
    :contentClass="'pa-0'"
    :hookSufix="'RealtimeModal'"
    disableDefaultPadding
    @onCloseHook="handleClose"
    noHeader
  >
    <template #content>
      <div style="position: relative; width: 100%; height: 100vh">
        <div id="map" style="width: 100%; height: 100%"></div>

        <div class="custom-close">
          <base-btn
            v-if="makingRequest"
            type="neutral"
            class="mr-2 rounded-pill"
            icon
          >
            <v-progress-circular
              :size="14"
              width="3"
              color="primary"
              indeterminate
            />
          </base-btn>
          <base-btn class="" type="neutral" @click="handleClose">
            <v-icon small>mdi-close</v-icon> {{ $t('message.actions.close') }}
          </base-btn>
        </div>
        <div class="custom-zoom-controls pr-16">
          <base-btn type="neutral" @click="zoomIn" icon>
            <simple-svg
              custom-class-name="custom-zommRealtime-svg"
              width="20"
              :src="require('@/assets/zoomIn.svg')"
            />
          </base-btn>
          <base-btn type="neutral" @click="zoomOut" icon>
            <simple-svg
              custom-class-name="custom-zommRealtime-svg"
              width="20"
              :src="require('@/assets/zoomOut.svg')"
            />
          </base-btn>
        </div>
      </div>

      <v-col class="total-users" cols="12" style="width: 400px">
        <v-row class="px-2 flex-column">
          <v-card elevation="0" class="ml-3 onLive pa-4 ga-2 mt-4">
            <div class="d-flex ga-2">
              <img src="@/assets/on-live.svg" alt="On-Live Icon" />
              <span class="body-bold-large ml-2">
                {{ $t('message.pages.analytics.realtimeTitle') }}</span
              >
            </div>
            <div style="width: 100%">
              <VideosFilterPicker
                fullWidth
                :label="
                  $t('message.pages.analyticsV3.videosFilter.picker.label')
                "
              />
            </div>
            <v-row class="ma-0 time-range-input" align="center">
              <v-icon size="20px">mdi-clock-outline</v-icon>
              <v-slider
                v-model="timeRangeIndex"
                class="mb-n5 pl-2"
                max="8"
                min="0"
              ></v-slider>
              <span
                class="pl-2 body-bold-smaller text-center"
                style="width: 80px"
                >{{ timeRangeText }}</span
              >
            </v-row>
          </v-card>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div style="width: 360px" class="ma-3" v-bind="attrs" v-on="on">
                <v-card
                  elevation="0"
                  class="px-4 pt-4 card-item d-flex align-center"
                >
                  <v-row
                    v-if="detailPopup.country"
                    :key="detailPopup.country"
                    class="details-region d-flex mt-1 align-center"
                  >
                    <country-flag
                      v-if="detailPopup.country"
                      :country="getCountryCode(detailPopup.country)"
                      class="mr-1 mb-1"
                    />
                    <div
                      class="pa-0 d-flex flex-column"
                      v-if="
                        detailPopup.country ||
                        detailPopup.region ||
                        detailPopup.cityRegion
                      "
                    >
                      <span
                        class="body-bold-base neutral-20-dark--text"
                        style="line-height: 100%"
                      >
                        {{ formattedCity }}
                      </span>
                      <span
                        v-if="formattedRegionCountry"
                        class="body-regular-small neutral-40-light--text"
                        style="line-height: 100%"
                      >
                        {{ formattedRegionCountry }}
                      </span>
                    </div>
                  </v-row>
                  <div class="pa-6 inside-card">
                    <span class="body-bold-xlarge neutral-20-dark--text">{{
                      !detailPopup.detailItems.length
                        ? totalUsers
                        : detailPopup.detailItems.length
                    }}</span>
                    <span
                      class="body-label-caption neutral-40-light--text"
                      style="z-index: 50000"
                    >
                      {{ $t('message.pages.analytics.peopleWatching') }}</span
                    >
                  </div>
                  <v-list
                    flat
                    dense
                    style="overflow-y: auto; max-height: 60vh"
                    class="pt-0"
                  >
                    <v-list-item-group
                      class="mt-2"
                      color="primary"
                      v-model="selectedListIndex"
                      @change="handleSelectUser"
                      active-class=""
                    >
                      <v-list-item
                        v-for="(item, i) in detailPopup.detailItems"
                        :key="'item-' + i"
                        class="px-1"
                        :class="{
                          bottomBorderList:
                            i !== detailPopup.detailItems.length - 1,
                        }"
                      >
                        <template v-slot:default>
                          <v-list-item-content class="pl-2 py-4">
                            <span
                              class="body-regular-small neutral-20-dark--text text-truncate"
                              style="max-width: 330px; display: inline-block"
                            >
                              {{ getTitleByExternalId(item.video_external_id) }}
                            </span>

                            <div class="d-flex align-center">
                              <div class="loadingDevice">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on">
                                      <simple-svg
                                        v-if="item.device_type === 'mobile'"
                                        :src="
                                          require('@/assets/device-vertical.svg')
                                        "
                                        custom-class-name="custom-zommRealtime-svg"
                                        width="17px"
                                        class="mr-1"
                                      />
                                      <simple-svg
                                        v-else-if="item.device_type === null"
                                        :src="
                                          require('@/assets/device-horizontal.svg')
                                        "
                                        custom-class-name="custom-zommRealtime-svg"
                                        width="17px"
                                        class="mr-1"
                                      />
                                      <simple-svg
                                        v-else
                                        :src="
                                          require('@/assets/position-view.svg')
                                        "
                                        custom-class-name="custom-zommRealtime-svg"
                                        width="17px"
                                        class="mr-1"
                                      />
                                    </span>
                                  </template>
                                  <span>
                                    {{
                                      item.device_type === 'mobile'
                                        ? 'Mobile'
                                        : item.device_type === null
                                        ? 'Desktop'
                                        : $t(
                                            'message.pages.analyticsV3.pages.devices.categories.others.name'
                                          )
                                    }}
                                  </span>
                                </v-tooltip>
                              </div>
                              <span
                                class="body-regular-smaller neutral-40-light--text"
                                >{{ `${item.ip}` }}</span
                              >
                            </div>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </div>
            </template>
            <span
              >Desktop: {{ devices.desktop }} ({{ devicePercent.desktop }})
              Mobile: {{ devices.mobile }} ({{ devicePercent.mobile }}) Others:
              {{ devices.others }} ({{ devicePercent.others }})</span
            >
          </v-tooltip>
        </v-row>
      </v-col>
      <v-dialog
        v-if="detailPopup.dialogOpen"
        :value="detailPopup.dialogOpen"
        style="z-index: 9999; border-radius: 8px"
        width="600px"
      >
        <v-card>
          <v-toolbar elevation="0" class="py-2 mb-4">
            <v-toolbar-title
              class="body-bold-medium neutral-20-dark--text d-flex flex-column px-2"
            >
              {{ detailPopup.selectedUser.video.title }}

              <span class="body-regular-smaller neutral-40-light--text mt-1">
                {{ detailPopup.selectedUser.user.ip }}
              </span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon @click="detailPopup.dialogOpen = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-col cols="12" class="pt-0" style="font-size: 13px">
            <v-col cols="12" class="pt-0">
              <div class="preview-container">
                <v-row class="ma-0" align="center" justify="center">
                  <div style="width: 550px" class="align-center justify-center">
                    <v-img
                      style="border-radius: 8px"
                      height="310px"
                      :src="detailPopup.selectedUser.video.thumbnail"
                    >
                      <template v-slot:placeholder>
                        <v-skeleton-loader
                          type="image"
                          width="100%"
                          class="fill-heightSkeleton"
                        />
                      </template>
                    </v-img>
                  </div>
                </v-row>
                <v-row
                  class="ma-0 mt-4 progress-container"
                  align="center"
                  justify="center"
                >
                  <div class="wrapper-progress-container">
                    <div class="wrapper-progress"></div>
                    <div
                      class="progress-content"
                      :style="`width: ${handleThreatProgressBarPercentage(
                        detailPopup.selectedUser.video.progress
                      )}%`"
                    ></div>
                  </div>
                  <span v-if="loadings.fetchUser">
                    <v-skeleton-loader type="text" width="80%" height="20px" />
                  </span>
                  <span
                    v-else
                    class="mt-2 body-regular-smaller"
                    style="width: 100%"
                  >
                    {{
                      secondsToMinuteSeconds(
                        detailPopup.selectedUser.video.current_time
                      )
                    }}/{{
                      secondsToMinuteSeconds(
                        detailPopup.selectedUser.video.duration
                      )
                    }}</span
                  >
                </v-row>
              </div>
              <v-row justify="space-between" class="ma-0 mb-4 mt-8">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.analytics.lastContact') }}
                </span>
                <span v-if="loadings.fetchUser">
                  <v-skeleton-loader type="text" width="80%" height="20px" />
                </span>
                <span v-else class="body-regular-small neutral-40-light--text">
                  {{ detailPopup.selectedUser.user.last_request }}
                </span>
              </v-row>

              <v-row justify="space-between" class="ma-0 my-4">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.analytics.browser') }}
                </span>
                <span v-if="loadings.fetchUser">
                  <v-skeleton-loader type="text" width="80%" />
                </span>
                <span v-else class="body-regular-small neutral-40-light--text">
                  {{ detailPopup.selectedUser.user.browser_name }} -
                  {{ detailPopup.selectedUser.user.browser_version }}
                </span>
              </v-row>

              <v-row justify="space-between" class="ma-0 my-4">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.analytics.operationalSystem') }}
                </span>
                <span v-if="loadings.fetchUser">
                  <v-skeleton-loader type="text" width="80%" />
                </span>
                <span v-else class="body-regular-small neutral-40-light--text">
                  {{ detailPopup.selectedUser.user.os_name }} -
                  {{ detailPopup.selectedUser.user.os_version }}
                </span>
              </v-row>

              <v-row justify="space-between" class="ma-0 my-4">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.analytics.device') }}
                </span>
                <span v-if="loadings.fetchUser">
                  <v-skeleton-loader type="text" width="80%" />
                </span>
                <span v-else class="body-regular-small neutral-40-light--text">
                  {{ detailPopup.selectedUser.user.device_type }} -
                  {{ detailPopup.selectedUser.user.device_model }}
                </span>
              </v-row>

              <v-row justify="space-between" class="ma-0 my-4">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.analytics.realtime.local') }}
                </span>
                <span v-if="loadings.fetchUser">
                  <v-skeleton-loader type="text" width="80%" />
                </span>
                <span
                  v-else
                  class="body-regular-small neutral-40-light--text d-flex"
                  style="position: relative"
                >
                  <country-flag
                    v-if="detailPopup.country"
                    :country="
                      getCountryCode(detailPopup.selectedUser.user.country)
                    "
                    size="normal"
                    class="mr-1 mb-1 country-flagUserSelected"
                  />
                  {{ detailPopup.selectedUser.user.city }}/{{
                    detailPopup.selectedUser.user.region
                  }}
                  - {{ detailPopup.selectedUser.user.country }}
                </span>
              </v-row>
              <v-row justify="space-between" class="ma-0 mt-4">
                <span class="body-regular-small neutral-20-dark--text">
                  {{ $t('message.pages.analytics.reference') }}
                </span>
                <span v-if="loadings.fetchUser">
                  <v-skeleton-loader type="text" width="80%" />
                </span>
                <span v-else class="body-regular-small neutral-40-light--text">
                  {{ detailPopup.selectedUser.user.referrer }}
                </span>
              </v-row>
            </v-col>
          </v-col>
        </v-card>
      </v-dialog>
    </template>
  </BaseModal>
</template>

<script>
// external imports
import { format, subMinutes } from 'date-fns'
import L from 'leaflet'
import { mapState } from 'vuex'

// API
import analyticsApi from '@/services/newAnalyticsApi'
import videosApi from '@/services/videosApi'

// Components
import VideosFilterPicker from '../../components/VideosFilter/VideosFilterPicker.vue'
import BaseModal from '@/components/BaseModal.vue'
import CountryFlag from 'vue-country-flag'

// CSS
import 'leaflet/dist/leaflet.css'

import i18n from '@/translations/lang'

export default {
  name: 'Realtime',
  components: {
    VideosFilterPicker,
    BaseModal,
    CountryFlag,
  },
  data() {
    return {
      open: true,
      map: null,
      makingRequest: false,
      animationProgressbarRealTime: null,
      selectedListIndex: null,
      lastSelectedListIndex: null,
      timeoutRange: null,
      timeRanges: [
        {
          text: `24 ${i18n.t('message.pages.analytics.realtime.hours')}`,
          seconds: 3600 * 24,
        },
        {
          text: `12 ${i18n.t('message.pages.analytics.realtime.hours')}`,
          seconds: 3600 * 12,
        },
        {
          text: `6 ${i18n.t('message.pages.analytics.realtime.hours')}`,
          seconds: 3600 * 6,
        },
        {
          text: `3 ${i18n.t('message.pages.analytics.realtime.hours')}`,
          seconds: 3600 * 3,
        },
        {
          text: `1 ${i18n.t('message.pages.analytics.realtime.hour')}`,
          seconds: 3600,
        },
        {
          text: `30 ${i18n.t('message.pages.analytics.realtime.minutes')}`,
          seconds: 1800,
        },
        {
          text: `10 ${i18n.t('message.pages.analytics.realtime.minutes')}`,
          seconds: 600,
        },
        {
          text: `5 ${i18n.t('message.pages.analytics.realtime.minutes')}`,
          seconds: 300,
        },
        {
          text: `${i18n.t('message.pages.analytics.realtime.now')}`,
          seconds: 60 * 2,
        },
      ],
      texts: [],
      geojson: null,
      totalUsers: 0,
      loadings: {
        fetchCluster: false,
        fetchUser: false,
      },
      devices: {
        desktop: 0,
        mobile: 0,
        tablet: 0,
      },
      errors: {
        fetchCluster: null,
        fetchUser: null,
      },
      devicePercent: {
        desktop: '0%',
        mobile: '0%',
        others: '0%',
      },
      timeRangeIndex: 8,
      detailPopup: {
        detailItems: [],
        country: null,
        cityRegion: null,
        selectedUser: {
          requests: [],
          user: {},
          video: {},
        },
        dialogOpen: false,
      },
      updateTimeout: null,
      externalIdToTitleMap: {},
      allVideos: [],
      selectedClusterId: null,
      shouldCenterOnSelected: false,
      svgLoaded: {},
      isRealtimeClosed: false,
    }
  },
  computed: {
    ...mapState({
      selectedVideos: (state) =>
        state.analytics.filters.filterVideos.selectedVideos,
    }),
    timeRangeText() {
      return this.timeRanges[this.timeRangeIndex].text
    },
    headerMenu() {
      return [
        {
          title: i18n.t('message.pages.analytics.history'),
          to: { name: 'AnalyticsV2Account' },
        },
        {
          title: i18n.t('message.routesTitles.AnalyticsV2Realtime'),
          to: { name: 'AnalyticsV2Realtime' },
        },
      ]
    },
    formattedCity() {
      return this.detailPopup.cityRegion || ''
    },
    formattedRegionCountry() {
      const region = this.detailPopup.region
      const country = this.detailPopup.country
      if (region && country) return `${region}/${country}`
      if (region) return region
      if (country) return country
      return ''
    },
  },
  methods: {
    closeModal() {
      this.isRealtimeClosed = true
      this.detailPopup.detailItems = []
      this.detailPopup.country = null
      this.detailPopup.cityRegion = null
      this.detailPopup.region = null
      this.detailPopup.selectedUser = {
        requests: [],
        user: {},
        video: {},
      }
      this.loadings.fetchUser = false
      this.detailPopup.dialogOpen = false
      this.svgLoaded = {}
      if (this.map) {
        this.map.remove()
        this.map = null
      }
      this.$root.$emit('closeRealtimeModal')
    },
    initMap() {
      if (this.map) {
        this.$nextTick(() => {
          this.map.invalidateSize()
        })
        return
      }
      const mapContainer = document.getElementById('map')
      if (!mapContainer) return
      this.map = L.map('map', { zoomControl: false }).setView([0, 0], 3)
      const southWest = L.latLng(-89.98155760646617, -180)
      const northEast = L.latLng(89.99346179538875, 180)
      const bounds = L.latLngBounds(southWest, northEast)
      this.map.options.minZoom = 3
      this.map.setMaxBounds(bounds)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(this.map)
      this.map.on('zoomend', this.getAndApplyData)
      this.map.on('moveend', this.getAndApplyData)
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState == 'visible') {
          this.getAndApplyData()
          clearInterval(this.updateTimeout)
          this.updateTimeout = setInterval(this.getAndApplyData, 10000)
        } else {
          clearInterval(this.updateTimeout)
        }
      })
      this.logAllVideos()
      this.getAndApplyData()
      this.$nextTick(() => {
        setTimeout(() => {
          this.map.invalidateSize()
        }, 300)
      })
    },
    handleClose() {
      this.closeModal()
    },
    handleSelectVideo(video) {
      this.$router.push({
        name: 'VideoPage',
        params: { id: video.id },
      })
    },
    zoomIn() {
      if (this.map) this.map.zoomIn()
    },
    zoomOut() {
      if (this.map) this.map.zoomOut()
    },
    async getAndApplyData() {
      if (document.visibilityState != 'visible' || this.makingRequest) {
        return
      }
      this.makingRequest = true
      try {
        let selectedVideosParam = null
        if (
          this.selectedVideos &&
          Array.isArray(this.selectedVideos) &&
          this.selectedVideos.length > 0
        ) {
          selectedVideosParam = this.selectedVideos
            .map((video) =>
              (video.videoExternalId || video.videoId || '').substring(0, 8)
            )
            .filter((id) => !!id)
        }
        const { data } = await analyticsApi.getRealtime(
          this.map.getBounds().toBBoxString(),
          this.map.getZoom(),
          this.timeRanges[this.timeRangeIndex].seconds,
          undefined,
          selectedVideosParam
        )
        let filteredGeojson = data.geojson
        if (
          this.selectedVideos &&
          Array.isArray(this.selectedVideos) &&
          this.selectedVideos.length > 0 &&
          filteredGeojson &&
          Array.isArray(filteredGeojson.features)
        ) {
          const selectedExternalIds = this.selectedVideos.map(
            (v) => v.video_external_id || v.external_id || v.id
          )
          filteredGeojson = {
            ...filteredGeojson,
            features: filteredGeojson.features.filter((f) =>
              selectedExternalIds.includes(f.properties.video_external_id)
            ),
          }
        }
        if (this.geojson) {
          this.geojson.remove()
        }
        this.texts.forEach((text) => {
          text.remove()
        })
        this.texts = []
        this.totalUsers = data.total_users
        this.devices = data.devices
        if (this.totalUsers !== 0) {
          this.devicePercent = {
            desktop: `${(
              (this.devices.desktop / data?.total_users) *
              100
            ).toFixed(0)}%`,
            mobile: `${((this.devices.mobile / data.total_users) * 100).toFixed(
              0
            )}%`,
            others: `${((this.devices.others / data.total_users) * 100).toFixed(
              0
            )}%`,
          }
        } else {
          this.devicePercent = {
            desktop: '0%',
            mobile: '0%',
            others: '0%',
          }
        }
        const _this = this
        this.geojson = L.geoJson(filteredGeojson, {
          pointToLayer(feature, latlng) {
            const lat = Number(latlng?.lat || 0)
            const lng = Number(latlng?.lng || 0)
            if (isNaN(lat) || isNaN(lng)) return
            const pointsSize = feature.properties.point_count || 1
            const minSize = 32
            const maxSize = 150
            let circleSize = minSize
            if (pointsSize >= 1000) {
              circleSize = maxSize
            } else if (pointsSize > 50) {
              circleSize =
                minSize +
                ((pointsSize - 50) / (1000 - 50)) * (maxSize - minSize)
              circleSize = Math.round(circleSize)
            }
            const markerId =
              feature.properties.cluster_id || feature.properties.user_id
            const isSelected =
              _this.selectedClusterId && markerId === _this.selectedClusterId
            if (isSelected && _this.shouldCenterOnSelected) {
              _this.shouldCenterOnSelected = false
              _this.map.setView([lat, lng], _this.map.getZoom(), {
                animate: true,
              })
            }
            let extraClass = ''
            if (isSelected) {
              extraClass = ' selected-marker'
            } else if (_this.selectedClusterId) {
              extraClass = ' faded-marker'
            }
            const marker = L.marker([lat, lng], {
              icon: L.divIcon({
                iconSize: [circleSize, circleSize],
                html: `<div class="panda-realtime-marker${extraClass}" style="width: ${circleSize}px; height: ${circleSize}px;">${pointsSize}</div>`,
              }),
            })
            marker.on('click', () => {
              _this.onSelectMarker(feature.properties)
            })
            return marker
          },
        }).addTo(this.map)
      } catch (error) {
        console.log(error)
      }
      this.makingRequest = false
    },
    async onSelectMarker(props) {
      let selectedVideosParam = null
      if (
        this.selectedVideos &&
        Array.isArray(this.selectedVideos) &&
        this.selectedVideos.length > 0
      ) {
        selectedVideosParam = this.selectedVideos
          .map((v) =>
            (v.videoExternalId || v.videoId || v.id || '').substring(0, 8)
          )
          .filter((id) => !!id)
      }
      if (props.cluster) {
        try {
          this.loadings.fetchCluster = true
          const { data } = await analyticsApi.getRealtime(
            this.map.getBounds().toBBoxString(),
            this.map.getZoom(),
            this.timeRanges[this.timeRangeIndex].seconds,
            props.cluster_id,
            selectedVideosParam
          )
          this.loadings.fetchCluster = false
          this.detailPopup.detailItems = data.map((item) => ({
            ...item.properties,
            user_id: `${item.properties.user_id}`,
          }))
          const firstItem = data[0].properties
          const isSameRegion = this.detailPopup.detailItems.every(
            (item) => item.region === firstItem.region
          )
          const isSameCountry = this.detailPopup.detailItems.every(
            (item) => item.country === firstItem.country
          )
          const isSameCity = this.detailPopup.detailItems.every(
            (item) => item.city === firstItem.city
          )
          this.detailPopup.country = isSameCountry ? firstItem.country : null
          this.detailPopup.cityRegion = isSameCity
            ? firstItem.city
            : isSameRegion
            ? firstItem.region
            : null
          this.detailPopup.region = isSameRegion ? firstItem.region : null
          this.errors.fetchCluster = false
        } catch (error) {
          this.loadings.fetchCluster = false
          this.errors.fetchCluster = true
          console.log(error)
        }
      } else {
        this.detailPopup.detailItems = [
          {
            ...props,
            user_id: `${props.user_id}`,
          },
        ]
        this.detailPopup.region = props.region || null
        this.detailPopup.country = props.country || null
        this.detailPopup.cityRegion = props.city || null
      }
      this.selectedClusterId = props.cluster_id || props.user_id || null
      this.shouldCenterOnSelected = true
      await this.getAndApplyData()
    },

    async fetchUser() {
      const selected = this.detailPopup.detailItems[this.selectedListIndex]

      if (!selected) {
        return
      }

      const { data } = await analyticsApi.getRealtimeUser(
        selected.user_id,
        selected.video_external_id
      )
      this.detailPopup.selectedUser = data
    },

    async userDataDialog() {
      const selected = this.detailPopup.detailItems[this.selectedListIndex]
      if (!selected) {
        this.detailPopup.selectedUser = null
        this.detailPopup.dialogOpen = false
        return
      }

      const last_request =
        this.detailPopup.selectedUser.requests[
          this.detailPopup.selectedUser.requests.length - 1
        ]
      const lastRequestDate = new Date(last_request.ts)

      const now = new Date()
      const diffMs = now - lastRequestDate
      const diffMinutes = Math.floor(diffMs / (1000 * 60))
      const diffHours = diffMs / (1000 * 60 * 60)
      if (diffMinutes < 60) {
        if (diffMinutes <= 0) {
          this.detailPopup.selectedUser.user.last_request = `🔴 ${i18n.t(
            'message.pages.analytics.watchingNow'
          )}`
          return
        }
        const time = `${diffMinutes} min`
        this.detailPopup.selectedUser.user.last_request = i18n.t(
          'message.pages.analytics.lastViewTime',
          { time }
        )
      } else if (diffHours < 24) {
        const hours = Math.floor(diffMinutes / 60)
        const time = `${hours} h`
        this.detailPopup.selectedUser.user.last_request = i18n.t(
          'message.pages.analytics.lastViewTime',
          { time }
        )
      } else {
        // 24 horas ou mais: exibe data completa
        this.detailPopup.selectedUser.user.last_request = format(
          lastRequestDate,
          'dd/MM/yyyy HH:mm:ss'
        )
      }

      if (this.animationProgressbarRealTime === null) {
        this.animationProgressbarRealTime = Math.floor(
          last_request.current_time || 0
        )
      } else if (
        this.animationProgressbarRealTime !== 0 &&
        this.animationProgressbarRealTime <
          Math.floor(last_request.current_time) + 60 &&
        lastRequestDate > subMinutes(new Date(), 1.2)
      ) {
        this.animationProgressbarRealTime++
      }

      const duration = Math.floor(
        this.detailPopup.selectedUser.video.duration || 0
      )
      let currentTime = Math.floor(this.animationProgressbarRealTime || 0)
      if (!last_request.current_time) {
        currentTime = 0
      }
      if (currentTime >= duration) {
        currentTime = duration
        this.animationProgressbarRealTime = duration
      }
      this.detailPopup.selectedUser.video.current_time = currentTime
      this.detailPopup.selectedUser.video.progress =
        duration > 0 ? (currentTime * 100) / duration : 0
      if (this.detailPopup.selectedUser.video.progress > 100) {
        this.detailPopup.selectedUser.video.progress = 100
      }

      this.detailPopup = { ...this.detailPopup }
      this.detailPopup.selectedUser.user_id = selected.user_id

      !this.detailPopup.dialogOpen
        ? (this.animationProgressbarRealTime = null)
        : this.animationProgressbarRealTime

      this.loadings.fetchUser = false
    },
    handleThreatProgressBarPercentage(value) {
      if (Number.isNaN(value) || value < 0) return 0
      if (value > 100) return 100
      return Math.floor(value)
    },
    secondsToMinuteSeconds(seconds) {
      const safeSeconds = Math.floor(Number(seconds) || 0)
      const minutes = Math.floor(safeSeconds / 60)
      const secondsLeft = safeSeconds % 60
      return `${minutes}:${secondsLeft < 10 ? '0' : ''}${secondsLeft}`
    },
    async handleSelectUser() {
      if (this.isRealtimeClosed) return
      this.detailPopup.dialogOpen = true
      if (this.selectedListIndex === undefined) {
        this.selectedListIndex = this.lastSelectedListIndex
      }
      this.lastSelectedListIndex = this.selectedListIndex

      // ZERA OS DADOS ANTES DE CARREGAR
      this.loadings.fetchUser = true
      this.detailPopup.selectedUser = {
        requests: [],
        user: {},
        video: { thumbnail: '' },
      }
      await this.$nextTick()

      try {
        await this.fetchUser()
        await this.userDataDialog()
        this.errors.fetchUser = false
      } catch (error) {
        console.log(error)
        this.errors.fetchUser = true
      }
      this.loadings.fetchUser = false
    },
    async logAllVideos() {
      try {
        const { data } = await videosApi.getAllVideosAndBin()
        let allVideos = []
        if (data && data.videos) {
          Object.values(data.videos).forEach((videosArr) => {
            allVideos = allVideos.concat(videosArr)
          })
        }
        this.allVideos = allVideos
      } catch (e) {
        console.error('Erro ao buscar todos os vídeos:', e)
      }
    },
    getTitleByExternalId(externalId) {
      if (!this.allVideos || !externalId) return ''
      const found = this.allVideos.find(
        (video) => video.video_external_id === externalId
      )

      return found ? found.title : ''
    },
    getCountryCode(countryName) {
      if (!countryName) return ''
      if (countryName.length === 2) return countryName.toLowerCase()
      const map = {
        Brasil: 'br',
        Brazil: 'br',
        'Estados Unidos': 'us',
        'United States': 'us',
        Argentina: 'ar',
        Espanha: 'es',
        Spain: 'es',
      }
      return map[countryName] || countryName.slice(0, 2).toLowerCase()
    },
    onSvgLoad(index) {
      this.$set(this.svgLoaded, index, true)
    },
  },
  watch: {
    open(val) {
      if (val) {
        this.isRealtimeClosed = false
      }
    },
    timeRangeIndex() {
      // Ao mudar o slider de tempo, desmarcar cluster e limpar listagem
      this.selectedClusterId = null
      this.shouldCenterOnSelected = false
      this.detailPopup.country = null
      this.detailPopup.cityRegion = null
      this.detailPopup.region = null
      this.detailPopup.detailItems = []
      clearTimeout(this.timeoutRange)
      this.timeoutRange = setTimeout(() => {
        this.getAndApplyData()
      }, 500)
    },
    selectedVideos: {
      handler() {
        // Ao filtrar vídeos, desmarcar cluster e limpar listagem
        this.selectedClusterId = null
        this.shouldCenterOnSelected = false
        this.detailPopup.country = null
        this.detailPopup.cityRegion = null
        this.detailPopup.region = null
        this.detailPopup.detailItems = []
        this.getAndApplyData()
        if (this.map) {
          this.map.invalidateSize()
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.isRealtimeClosed = false
    this.detailPopup.dialogOpen = false
    this.$root.$on('openRealtimeModal', () => {
      this.isRealtimeClosed = false
      this.open = true
      this.$nextTick(() => {
        setTimeout(() => {
          this.initMap()
          if (this.map) {
            setTimeout(() => {
              this.map.invalidateSize()
            }, 300)
          }
        }, 300)
      })
    })
  },
  beforeDestroy() {
    this.$root.$off('openRealtimeModal')
  },
}
</script>

<style lang="scss" scoped>
.bottomBorderList {
  border-bottom: 1px solid varFigma(neutral-95-lightest);
}
.contentUserList {
  padding: 16px 0;
}
.country-flagUserSelected {
  position: absolute;
  left: -37px;
  bottom: -13px;
}
.wrapper-progress {
  width: 100%;
  height: 2px;
  background: #f5f5f5;
  border-radius: 15px;
}
.preview-container {
  border-radius: 8px;
  position: relative;
  height: 310px;
}
.video-chart-container {
  position: absolute;
  width: 100%;
  top: 20px;
  padding-left: 60px;
  padding-right: 50px;
}
.wrapper-progress-container {
  width: 520px;
  height: calc(100% - 73px);
  position: relative;
  top: 0;
  left: 0;
}
.custom-close {
  z-index: 1001;
  display: flex;
  position: absolute;
  top: 24px;
  right: 24px;
}
.custom-zoom-controls {
  position: absolute;
  bottom: 24px;
  right: 24px;
  display: flex;
  gap: 8px;
  z-index: 1001;
}
.progress-container {
  position: absolute;
  bottom: 4%;
  left: 50%;
  transform: translateX(-50%);
  color: white;
}
.progress-content {
  height: 2px;
  background: var(--v-primary-base);

  border-radius: 15px;
  position: absolute;
  top: 0;
  left: 0;
}
.onLive {
  z-index: 9999;
  width: 360px;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  border-radius: 8px !important;
  margin-left: 8px;

  .time-range-input {
    border: thin solid varFigma(neutral-95-lightest);
    border-radius: 8px !important;
    padding: 0 8px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.users-card {
  position: absolute;
  top: 30px;
  right: 30px;
  border-radius: 8px;
  z-index: 1000;
}
#map {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.total-users {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
}
.details-region {
  width: 100%;
  margin-bottom: 8px;
}
.card-item {
  background: varFigma(neutral-100-white);
  width: 100%;
  min-height: 132px;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  justify-content: center;

  .inside-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    border-radius: 8px;
    background-color: varFigma(neutral-99);
    overflow: hidden;
  }
}

.card-item-background-shape {
  position: absolute;
  top: 0;
  left: 0;
  margin-top: auto;
  width: 100%;
  height: calc(100% - 73px);
  display: flex;
  border-radius: 10px;
}
.loadingDevice {
  width: 20px;
  min-width: 20px;
  height: 10px;
  margin-right: 3px;
  display: flex;
  align-items: center;
  justify-content: start;
}
.card-item-background-shape svg {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: auto;
  border-radius: 10px;
}
</style>
<style lang="scss">
.custom-zommRealtime-svg {
  width: 17px !important;
  height: 30px !important;
  display: block;
  margin: 0 auto;
  fill: varFigma(neutral-40-light) !important;
  max-width: 20px;
}
.panda-realtime-marker {
  transform: translate(-50%, -50%);
  box-shadow: 0 0 0 0 transparent;
  font-family: 'Rubik', sans-serif !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  border-radius: 50%;
  color: white;
  background-color: #3f55ee;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  opacity: 0.85;
}
.panda-realtime-marker.selected-marker {
  border: 3px solid #fff;
  opacity: 1 !important;
  z-index: 10;
}
.panda-realtime-marker.faded-marker {
  opacity: 0.5 !important;
}
.panda-realtime-marker-text {
  position: absolute;
  color: #fff;
  font-weight: bold;
  font-size: 0.9rem;
}
@keyframes ripple-animation {
  0% {
    transform: scale(0.7);
    opacity: 1;
  }
  100% {
    transform: scale(1.8);
    opacity: 0;
  }
}
.panda-map-realtime-circle-ripple {
  width: 35px;
  height: 35px;
  border-radius: 100%;
  position: absolute;
  background: var(--v-primary-base);
  animation: ripple-animation 2s infinite ease-out;
}
.panda-map-realtime-circle-ripple-1 {
  animation-delay: 0s;
}
.panda-map-realtime-circle-ripple-2 {
  animation-delay: 700ms;
}
.leaflet-marker-icon {
  border: 0;
  background-color: transparent;
}
.leaflet-pane .leaflet-overlay-pane {
  margin-top: -50000px;
  margin-left: -50000px;
  width: calc(100000px + 100%);
  height: calc(100000px + 100%);
  background-color: rgba(0, 112, 206, 0.35);
}
.fill-heightSkeleton .v-skeleton-loader__image {
  height: 100%;
}
</style>
